var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicIcon,{tag:"Component",on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }